import { Reducer } from 'redux';

import { RequestReturnActionTypes, RequestReturnActions } from '../actions/RequestReturn';
import { IErrorActionData } from '../../../models/Error';

export interface IRequestReturnState {
  isProcessing: boolean;
  isSuccess: boolean;
  error?: IErrorActionData;
}

const initialRequestReturnState = {
  isProcessing: false,
  isSuccess: false,
  error: undefined,
} as IRequestReturnState;

const RequestReturnReducer: Reducer<IRequestReturnState, RequestReturnActions> = (
  state = initialRequestReturnState,
  action: RequestReturnActions,
): IRequestReturnState => {
  switch (action.type) {
    case RequestReturnActionTypes.REQUEST_RETURN:
      return {
        ...state,
        isProcessing: true,
        isSuccess: false,
        error: undefined,
      };

    case RequestReturnActionTypes.REQUEST_RETURN_SUCCESS: {
      return {
        ...state,
        isProcessing: false,
        isSuccess: true,
        error: undefined,
      };
    }

    case RequestReturnActionTypes.REQUEST_RETURN_FAILED:
      return {
        ...state,
        isProcessing: false,
        isSuccess: false,
        error: {
          errorCode: action.payload.errorCode,
          errorMessage: action.payload.errorMessage,
          callBack: action.payload.callBack,
        },
      };

    case RequestReturnActionTypes.REQUEST_RETURN_RESET:
      return initialRequestReturnState;

    default:
      return state;
  }
};

export default RequestReturnReducer;
